<div class="section-1200">
  <p class="heading">Material/Sample Information</p>
  <form [formGroup]="sampleDataPrecastForm" [ngClass]="{ 'disabled-wrapper': !makeSampleEditable }">
    <p class="required">* These fields are mandatory which need to be filled before proceeding further</p>
    <div formArrayName="samples">
      @for (sample of getSampleControls.controls; track sample; let i = $index) {
        <mat-card [formGroupName]="i" class="margin-bottom-20">
          <mat-card-content class="sample-info-card">
            <div class="row">
              <div class="col-sm-11">
                <div class="row">
                  <div class="col-md-3" [ngClass]="{ 'pre-approval-space': $safeNavigationMigration(companyData?.preApproval) }">
                    <mat-label class="mat-label"> Sample ID<span class="required">*</span> </mat-label>
                    <mat-form-field appearance="outline">
                      <input matInput formControlName="sampleId" />
                      @if (companyData?.preApproval) {
                        <mat-hint class="mat-hint-red"
                          >Please enter your Mix Design code in Sample ID field.
                        </mat-hint>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-3">
                    <mat-label class="mat-label">
                      Sample Date<span class="required">*</span>
                      <a
                        href="javascript:void(0)"
                        #tooltip="matTooltip"
                        alt="tooltip-information"
                        matTooltip="Date of sample cast and not sample collection">
                        <img src="/assets/icons/Alert-grey.svg" alt="alert-icon" />
                      </a>
                    </mat-label>
                    <mat-form-field appearance="outline" class="mat-form-field-width">
                      <input
                        formControlName="sampleCollectionDate"
                        [max]="currentDate"
                        class="mat-date-input"
                        readonly
                        matInput
                        [matDatepicker]="picker" />
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div class="col-md-3 online-type">
                      <mat-label class="mat-label"> Sample Type<span class="required">*</span> </mat-label>
                      <mat-form-field appearance="outline" class="mat-form-field-width">
                        <mat-select
                          (selectionChange)="sampleTypeChange()"
                          formControlName="sampleTypeMasterId"
                          disableOptionCentering
                          placeholder="Select">
                          @for (sampletype of sampleTypes; track sampletype) {
                            <mat-option [value]="sampletype.id" class="arrow">
                              {{ sampletype.label }}</mat-option
                              >
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-md-3">
                      <mat-label class="mat-label"> Samples Per Set<span class="required">*</span> </mat-label>
                      <mat-form-field appearance="outline">
                        <input
                          matInput
                          required
                          onkeydown="return !(event.keyCode == 69)"
                          type="number"
                          min="1"
                          max="3"
                          [length]="1"
                          appNumberInput
                          formControlName="numSamplesPerSet"/>
                        </mat-form-field>
                        @if (
                          getSampleControls.at(i).get('numSamplesPerSet')?.invalid &&
                          (getSampleControls.at(i).get('numSamplesPerSet')?.touched ||
                          getSampleControls.at(i).get('numSamplesPerSet')?.dirty)
                          ) {
                          <mat-error
                            class="mat-error-nativesoil"
                            style="margin: -26px 0px 0px 0px">
                            <span>{{ getErrorMessage(i) }}</span>
                          </mat-error>
                        }
                      </div>
                      <div class="col-md-3">
                        <mat-label class="mat-label">Mix Reference</mat-label>
                        <mat-form-field appearance="outline">
                          <input
                            matInput
                            formControlName="mixReference"
                            [matAutocomplete]="mixAuto"
                            maxlength="5"
                            (input)="searchMixReference(i, $event)">
                            <mat-autocomplete
                              #mixAuto="matAutocomplete"
                              [displayWith]="displayMixReference"
                              (optionSelected)="mixReferenceSelected(i, $event.option.value)">
                              @for (mix of filteredMixReferences[i]; track mix) {
                                <mat-option
                                  [value]="mix">
                                  <span class="mix-option">
                                    <strong>{{ mix.mixReference }}</strong>
                                    &nbsp;— {{ mix.mixDesignCode }}
                                  </span>
                                </mat-option>
                              }
                            </mat-autocomplete>
                          </mat-form-field>
                        </div>
                        <div class="col-md-3">
                          <mat-label class="mat-label">Mix Design Code</mat-label>
                          <mat-form-field appearance="outline" class="mat-form-field-width">
                            <input matInput
                              formControlName="mixDesignCode"
                              [readonly]="$safeNavigationMigration(getSampleControls.at(i).get('mixDesignCodeReadonly')?.value)"
                              maxlength="50" />
                            </mat-form-field>
                          </div>
                          <div class="col-md-3">
                            <mat-label class="mat-label"> Truck # </mat-label>
                            <mat-form-field appearance="outline" class="mat-form-field-width">
                              <input matInput formControlName="truckNumber" [maxLength]="10" />
                            </mat-form-field>
                          </div>
                          <div class="col-md-3">
                            <mat-label class="mat-label"> Ticket # </mat-label>
                            <mat-form-field appearance="outline" class="mat-form-field-width">
                              <input matInput formControlName="ticketNumber" [maxLength]="10" />
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      @if (getSampleControls.controls.length > 1) {
                        <div class="col-md-1">
                          @if (makeSampleEditable) {
                            <mat-icon
                              aria-hidden="false"
                              (click)="removeItem(i)"
                              class="remove-icon cursor"
                            aria-label="Remove Sample icon"></mat-icon>
                          }
                        </div>
                      }
                    </div>
                    @if (sampleDataPrecastForm.value.samples[i].isUnique) {
                      <mat-error
                        >Sample ID, Ticket # or Truck # already exists. Please enter a new valid input.</mat-error
                        >
                    }
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </form>
          <mat-card class="margin-bottom-20">
            <mat-card-content>
              <a
                [ngClass]="{ 'sample-disabled': !makeSampleEditable }"
                class="add-sample"
                href="javascript:void(0);"
                (click)="toggleButtonState()">
                <mat-icon class="add-icon"></mat-icon>
                <span class="alink"> Add Sample </span>
              </a>
            </mat-card-content>
          </mat-card>
        </div>
